import ctl from '@netlify/classnames-template-literals';

export const classes = {
  container: ctl(`
    flex 
    items-center
    gap-4 
    py-2 
    px-4
    cursor-pointer 
    hover:bg-platinum
    rounded-md 
    text-waterspout
  `),
  subMenu: ctl(`
    hidden
    absolute
    z-[10]
    top-full
    left-[60%]
    min-w-[210px] 
    shadow-cetacean-blue
    bg-anti-flash-white
    rounded-md
    rounded-tl-none
    flex-col
    -ml-4
    peer-[.nested-section]:peer-hover:flex
    hover:flex
  `),
};
